'use strict';

/* eslint-disable no-invalid-this */
/* eslint-disable no-console */
/* eslint-disable no-use-before-define*/
// eslint-disable-next-line
export default function(target, container = document) {
	let characterCount = 400;
	let isMobile = true;
	if (window.matchMedia('(min-width: 1170px)').matches) {
		characterCount = 800;
		isMobile = false;
	}

	// Target
	const readMoreTarget = container.querySelector(target);

	if (readMoreTarget === null) {
		console.error('Element does not exists.');
		return;
	}

	// Check if already initialized and exit if true
	if (readMoreTarget.getAttribute('data-read-more-initialized') === 'true') {
		return;
	}

	// Helper functions

	/**
	 * Will convert a string value into a Boolean
	 * @param  {String} string
	 */
	const toBoolean = function (string) {
		switch (string) {
			case 'true':
			case '1':
				return true;
			case 'false':
			case '0':
			case null:
				return false;
			default:
				return Boolean(string);
		}
	};

	// Defaults
	const readMoreTargetStyles = window.getComputedStyle(readMoreTarget);
	const readMoreTargetClone = readMoreTarget.cloneNode();
	let readMoreTargetCloneHeight = readMoreTargetClone.clientHeight;

	// Create temporary element to calculat the correct height of the set character amount
	readMoreTargetClone.textContent = readMoreTarget.textContent.substring(0, characterCount);
	readMoreTargetClone.style.width = readMoreTargetStyles.width;
	readMoreTargetClone.style.position = 'absolute';
	readMoreTargetClone.style.top = '0';
	readMoreTargetClone.style.left = '-100%';

	// Read More Target
	if (!readMoreTarget.classList.contains('c-read-more')) {
		readMoreTarget.classList.add('c-read-more');
	}

	// Button
	const readmoreMainTrigger = document.createElement('button');
	readmoreMainTrigger.setAttribute('class', 'c-read-more-trigger');
	readmoreMainTrigger.innerText = 'Read More';

	// Data Attributes
	readMoreTarget.dataset.state = false;
	readMoreTarget.classList.add('c-read-more--gradient');

	// Events: Functions

	// Set height the content and change the text of the trigger
	const onClick = function (event) {
		const currentTarget = event.currentTarget;
		switch (toBoolean(readMoreTarget.dataset.state)) {
			case true:
				readMoreTarget.classList.add('c-read-more--gradient');
				readMoreContent.style.height = readMoreTargetCloneHeight;
				currentTarget.innerText = 'Read More';
				break;
			case false:
				readMoreTarget.classList.remove('c-read-more--gradient');
				readMoreContent.style.height = null;
				currentTarget.innerText = 'Read Less';
				break;

			default:
				break;
		}

		readMoreTarget.dataset.state = !toBoolean(readMoreTarget.dataset.state);
	};

	// Events: Remove/Add
	readmoreMainTrigger.removeEventListener('click', onClick);
	readmoreMainTrigger.addEventListener('click', onClick);

	/**
	 * DOM Updates
	 * Create a wrapper of the HTML content
	 */
	const readMoreContent = document.createElement('div');
	readMoreContent.classList.add('c-read-more-content');
	readMoreContent.innerHTML = readMoreTarget.innerHTML;

	// Add a ellipses sibiling
	const readMoreEllipses = document.createElement('div');
	readMoreEllipses.classList.add('c-read-more-ellipses');
	readMoreEllipses.textContent = '...';

	// Calculate the height of the container with the specific character count
	if (container.body) {
		container.body.appendChild(readMoreTargetClone);
	}
	else {
		container.appendChild(readMoreTargetClone);
	}
	readMoreTargetCloneHeight = window.getComputedStyle(readMoreTargetClone).height;
	if (container.body) {
		container.body.removeChild(readMoreTargetClone);
	}
	else {
		container.removeChild(readMoreTargetClone);
	}

	if (isMobile === false) {
		readMoreTargetCloneHeight = parseFloat(readMoreTargetCloneHeight.replace('px', '')) * 1.21;
		readMoreTargetCloneHeight = `${readMoreTargetCloneHeight}px`;
	}

	// Set height of target
	readMoreContent.style.height = readMoreTargetCloneHeight;

	// Clear the original HTML and append elements
	readMoreTarget.innerHTML = '';
	readMoreTarget.appendChild(readMoreContent);
	readMoreContent.insertAdjacentElement('afterend', readMoreEllipses);

	// Append trigger
	readMoreTarget.insertAdjacentElement('afterend', readmoreMainTrigger);

	// Set data property
	readMoreTarget.setAttribute('data-read-more-initialized', 'true');
}
